<div class="reserve-loading-container">
  <img
    width="28"
    height="28"
    ngSrc="assets/img/img-loadingAI.png"
    alt="Loading Image"
    class="loading-image"
  />
  <h2>{{ 'reserve-loading.message' | translate }}</h2>
  <!--  動畫 圓點 -->
  <div class="dot-loader">
    <span></span>
    <span></span>
    <span></span>
  </div>
</div>
